import React from 'react';
export function Disclosure() {
  return <footer className="bg-gray-100 py-8 px-4 mt-16 border-t border-gray-200" data-id="element-227">
      <div className="max-w-4xl mx-auto text-center" data-id="element-228">
        <p className="text-xs text-gray-500 leading-relaxed max-w-2xl mx-auto" data-id="element-229">
          ADVERTORIAL DISCLOSURE: This is an advertisement for FlossFocus and
          The DeepClean Flow. Individual results may vary. This content is not
          intended as medical advice. Consult your dentist or healthcare
          provider for personalized recommendations. The story depicted is a
          dramatization based on real customer experiences.
        </p>
        <div className="mt-4 flex justify-center gap-4 text-xs text-gray-400" data-id="element-230">
          <span data-id="element-231">Privacy Policy</span>
          <span data-id="element-232">Terms of Service</span>
          <span data-id="element-233">Contact Us</span>
        </div>
        <p className="mt-4 text-xs text-gray-400" data-id="element-234">
          © 2026 FlossFocus. All rights reserved.
        </p>
      </div>
    </footer>;
}